(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmProcessCreateController', AdmProcessCreateController);

    AdmProcessCreateController.$inject = ['AdmService','$state'];

    function AdmProcessCreateController(AdmService, $state) {
        var vm                          = this;
        vm.activate                     = activate;
        vm.storeProcess                 = storeProcess;
        vm.create                       = [];
        vm.priorities                   = [{ id : 'LOW', name : 'Low'}, { id : 'MEDIUM', name : 'Medium'}, { id : 'HIGH', name : 'High'}];
        vm.getJobDescriptions           = getJobDescriptions;
        vm.getDepartments               = getDepartments;
        vm.form                         = [];
        vm.form.priority                = '';
        vm.form.stages                  = [{value : '', area : '', items : [{value : ''}]}];
        vm.addStage                     = addStage;
        vm.removeStage                  = removeStage;
        vm.addStageItem                 = addStageItem;
        vm.removeStageItem              = removeStageItem;
        vm.getResponsible               = getResponsible;
        vm.getResponsiblePositions      = getResponsiblePositions;
        vm.getStageResponsible          = getStageResponsible;
        vm.getStageResponsiblePositions = getStageResponsiblePositions;
        vm.cancel                       = cancel;

        function getJobDescriptions()
        {
            vm.query = {};
            AdmService.getJobDescriptionsForSelect(vm.query).then(function(response){
               vm.jobDescriptions = response.data;
            });
        }

        function getDepartments()
        {
            vm.query = {};
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.departments = response.data;
            });
        }

        function storeProcess()
        {
            vm.query = {};
            vm.query['department']  = vm.form.department;
            vm.query['responsible'] = vm.form.responsible;
            vm.query['position']    = vm.form.position;
            vm.query['name']        = vm.form.name;
            vm.query['priority']    = vm.form.priority;
            vm.query['where']       = vm.form.where;
            vm.query['description'] = vm.form.description;
            vm.query['stages']      = vm.form.stages;
            AdmService.storeProcess(vm.query).then(function(response){
                $state.go('root.adm.process.list');
            });
        }

        function addStage()
        {
            vm.form.stages.push({value : '', area : '', items : [{ value : ''}]});
        }

        function removeStage(field)
        {
            vm.form.stages.splice(vm.form.stages.indexOf(field), 1);
        }

        function addStageItem(stage)
        {
            stage.items.push({value : ''});
        }

        function removeStageItem(stage, item)
        {
            stage.items.splice(stage.items.indexOf(item), 1);
        }

        function getResponsible()
        {
            vm.query = {};
            vm.query['department'] = vm.form.department;
            AdmService.getResponsible(vm.query).then(function(response){
                vm.responsible = response.data;
                if(vm.responsible.length === 1){
                    vm.form.responsible = vm.responsible[0].id;
                }
            });
        }

        function getResponsiblePositions()
        {
            vm.query = {};
            vm.query['user'] = vm.form.responsible;
            AdmService.getResponsiblePositions(vm.query).then(function(response){
                vm.responsiblePositions = response.data;
                if(vm.responsiblePositions.length === 1){
                    vm.form.position = vm.responsiblePositions[0].id;
                }
            });
        }

        function getStageResponsible(stage)
        {
            vm.query = {};
            vm.query['department'] = stage.department;
            AdmService.getResponsible(vm.query).then(function(response){
                stage.responsibilities = response.data;
                if(stage.responsibilities.length === 1){
                    stage.responsibility = stage.responsibilities[0].id;
                }
            });
        }

        function getStageResponsiblePositions(stage)
        {
            vm.query = {};
            vm.query['user'] = stage.responsibility;
            AdmService.getResponsiblePositions(vm.query).then(function(response){
                stage.responsiblePositions = response.data;
                if(stage.responsiblePositions.length === 1){
                    stage.position = stage.responsiblePositions[0].id;
                }
            });
        }

        function cancel()
        {
            $state.go('root.adm.process.list');
        }

        function activate() {
            vm.getJobDescriptions();
            vm.getDepartments();
        }
        vm.activate();
    }

})();